import { environment } from "@app-environments/environment";


export enum DebugLevelEnum {
    TIMERS=0,
    VERBOSE = 1,
    INFO=2,
    WARNING=3,
    ERROR=4,
    ALL=5
  }
/**
 * generic class to log data
 */
export class DBG {
    /**
     * todo:load from file or set by app
     */
    public static DEBUG_LEVEL:DebugLevelEnum=environment.debuglevel;
    
    /**
     * 
     * @param level 
     * @param val log app data to console
     * @param msg 
     */
    public static log(level:DebugLevelEnum=DebugLevelEnum.INFO ,TAG:string, ... val:any){
        if (level>= DBG.DEBUG_LEVEL ){
            console.log("["+ DebugLevelEnum[level] + "] [" + TAG +  "] [" + new Date().toUTCString()+ "]" ,val);
        }
        
    }
}